import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IProceed,
  IProceedListRequest,
  IProceedCreateRequest,
  IProceedUpdateRequest,
  ProceedState,
} from "@/types/proceed";
import CustomRequest from "../customRequest";

const actions: ActionTree<ProceedState, RootState> = {
  async get({ commit }, proceed_id: number) {
    await CustomRequest.get<IProceed>({
      uri: `/proceed/${proceed_id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }) {
    await CustomRequest.get<IPagination<IProceed>>({
      uri: `/proceed`,
      commit,
      target: "pagination",
    });
  },

  async salesGet({ commit }, proceed_id: number) {
    await CustomRequest.get<IProceed>({
      uri: `/sales/proceed/${proceed_id}`,
      commit,
      target: "single",
    });
  },

  async salesGetList({ commit }, params: IProceedListRequest) {
    await CustomRequest.get<IPagination<IProceed>>({
      uri: `/sales/proceed/`,
      params,
      commit,
      target: "pagination",
    });
  },

  async salesUpdate(
    { commit },
    datas: { proceed_id: number; params: IProceedUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IProceed>({
      uri: `/sales/proceed/${datas.proceed_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesCreate({ commit }, params: IProceedCreateRequest) {
    const { error } = await CustomRequest.post<IProceed>({
      uri: `/sales/proceed`,
      params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesDelete({ commit }, proceed_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/proceed/${proceed_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
